export const relativeURL = (domain) => {
  const hasProtocol = () => /^(https?:\/\/)/.test(domain)
  const protocol = hasProtocol() ? '' : 'https://'

  const url = new URL(`${protocol}${domain}`)
  return url.pathname + url.search
}
